<template>
  <div class="container">
    <van-image
      class="img"
      fit="cover"
      :src="coverImageUrl"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
    </van-image>
  </div>
</template>

<script>
  import { Image as VanImage } from 'vant'
  import { Loading } from 'vant'
  import Vue from 'vue'
  Vue.use(VanImage)
  Vue.use(Loading)
  export default {
    name: "TopSwipeItem",
    components: {
    },
    props: {
      slug: {
        type: String,
        default: 'sanhao'
      },
      item: {
        type: Object,
        default: function () {
          return {
          }
        }
      }
    },
    data () {
      return {
        coverImageUrl: '',
        itemData: {}
      }
    },
    computed: {
    },
    methods: {
      getCoverImage: function(objectType, itemData) {
        let coverId
        switch (objectType) {
          case 'episode':
            coverId = itemData.poster
            break;
          case 'topic':
            coverId = itemData.cover     
            break
          default:
            break
        }
        this.$api.image.detail(coverId)
        .then(res => {
          this.coverImageUrl = res.data.private_cdns[0].cdn_url
        })
      },
      // imageLoad: function (e) {
      //   // window.console.log("image loaded:", e)
      //   this.$emit('imageonload', {
      //     imageHeight: e.path[0].height,
      //     imageWidth: e.path[0].width
      //   })
      // }
      getItem: function (objectType, objectId) {
        this.$api[objectType].detail(objectId)
        .then(res => {
          // window.console.log("获取 ITEM 成功", res.data)
          this.itemData = res.data
          this.getCoverImage(objectType, res.data)
        })
      }
    },
    watch: {},
    mounted () {
      this.getItem(this.item.objectType, this.item.objectId)
    },
  }
</script>

<style lang="css" scoped>
  .img {
    display: block;
    line-height: 0px;
  }
</style>
